<ng-container *ngrxLet="selectActiveLevel2$; let activeLevel2">
  <div class="h-100 w-100 flex-col">
    <ui-header
      [breadCrumbs]="breadCrumbs"
      *ngrxLet="selectAllCustomEvents$; let selectAllCustomEvents"
    >
      <ui-button
        *ngIf="
          (activeLevel2 === MenuKey.eventType &&
            selectAllCustomEvents?.length) ||
          activeLevel2 === MenuKey.eventTypeEdit ||
          activeLevel2 === MenuKey.eventTypeCreate
        "
        type="primary"
        (clickAction)="createEventType()"
      >
        {{
          activeLevel2 === MenuKey.eventTypeEdit
            ? ('DATABASE.BUTTONS.SAVE_TAG' | translate)
            : ('DATABASE.BUTTONS.CREATE_TAG' | translate)
        }}
      </ui-button>
      <ui-button
        *ngIf="activeLevel2 === MenuKey.createScheduleList"
        type="primary"
        (clickAction)="createEventType()"
      >
        <ng-container *ngrxLet="selectSelectedSchedule$; let selectedSchedule">
          {{
            selectedSchedule
              ? ('COMMON.SAVE' | translate)
              : ('DATABASE.BUTTONS.CREATE_SCHEDULE' | translate)
          }}
        </ng-container>
      </ui-button>
      <ui-button
        *ngIf="
          activeLevel2 === MenuKey.customObjects &&
          ((selectAllCustomObjects$ | async)?.length || (selectAllCustomObjectsStates$ | async)?.length)
        "
        type="primary"
        (clickAction)="onCreateCustomObject()"
      >{{ 'CUSTOM_OBJECTS.CREATE_CUSTOM_OBJECT' | translate }}
      </ui-button
      >

      <ui-button
        *ngIf="activeLevel2 === MenuKey.mapObjects"
        type="primary"
        (clickAction)="onCreateMapCustomObject()"
      >{{ 'CUSTOM_OBJECTS_MODAL.OPEN_BUTTON_TEXT' | translate }}
      </ui-button
      >

      <div
        *ngIf="!!orgGroupType && !!orgGroupName"
        class="flex-row gap-8 org-group-actions"
      >
        <span
          class="ui-icon-delete flex-row center-center"
          [matTooltip]="'DATABASE.TOOLTIPS.DELETE_GROUP' | translate"
          matTooltipClass="sidebar-tooltip"
          (click)="deleteGroup(orgGroup)"
        >
        </span>
        <span
          class="ui-icon-edit flex-row center-center"
          [matTooltip]="'DATABASE.TOOLTIPS.EDIT_GROUP' | translate"
          matTooltipClass="sidebar-tooltip"
          (click)="addEditGroup(orgGroup)"
        >
        </span>
      </div>
    </ui-header>
    <div class="flex-row content-wrapper icon-18">
      <div class="menu p-r" [class.collapsed]="collapsed">
        <!--        <span-->
        <!--            [class.collapsed]="collapsed"-->
        <!--            class="ui-icon-expand-arrow expand-sidebar"-->
        <!--            (click)="toggleMenu()"-->
        <!--        ></span>-->
        <ng-container *ngIf="isFaceRecognitionEnabled$ | async">
          <div
            *rbacOrgAllow="[permissions.OrganizationDatabasePeopleDirectory]"
            class="flex-row start-center"
          >
            <div
              class="menu-item flex-row start-center"
              (click)="toggleSubmenu(groupType.Persons)"
            >
              <span
                class="ui-icon-expand-arrow"
                [class.expanded]="menuExp[groupType.Persons]"
              ></span>
              <span class="menu-item-icon icon-18 mat-icon ui-icon-users"></span>
              <div class="label m-10">
                {{ 'DATABASE.PERSON_DIR' | translate }}
              </div>
            </div>
          </div>
          @if (menuExp[groupType.Persons]) {
            <div class="sub-menu flex-col gap-8">
              <div
                matTooltip="Person"
                [matTooltipDisabled]="!collapsed"
                matTooltipPosition="right"
                [routerLink]="routerSegments.persons"
                routerLinkActive="active"
              >
                {{ 'DATABASE.PERSONS' | translate }}
              </div>
              <div
                [routerLink]="routerSegments.personGroups"
                routerLinkActive="active"
              >
                {{ 'DATABASE.GROUPS' | translate }}
              </div>
            </div>
          }
        </ng-container>
        <ng-container *ifDeveloper>
          <div
            *rbacOrgAllow="[
              permissions.OrganizationDatabaseCustomObjectsDirectory,
            ]"
            class="flex-row start-center gap-10 menu-item"
            matTooltip="Uniforms"
            [matTooltipDisabled]="!collapsed"
            matTooltipPosition="right"
            [routerLink]="routerSegments.uniform"
            routerLinkActive="active"
          >
            <mat-icon
              class="menu-item-icon event-tags"
              svgIcon="uniform"
            ></mat-icon>
            <div class="label">{{ 'DATABASE.UNIFORM_DIR' | translate }}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="selectCustomObjectsEnabled$ | async">
          <div
            *rbacOrgAllow="[
              permissions.OrganizationDatabaseCustomObjectsDirectory,
            ]"
            class="flex-row start-center gap-10 menu-item"
            matTooltip="Custom objects"
            [matTooltipDisabled]="!collapsed"
            matTooltipPosition="right"
            [routerLink]="routerSegments.customObjects"
            routerLinkActive="active"
          >
            <mat-icon
              class="menu-item-icon event-tags"
              svgIcon="custom-object"
            ></mat-icon>
            <div class="label">
              {{ 'DATABASE.CUSTOM_OBJECTS_DIR' | translate }}
            </div>
          </div>
        </ng-container>
        <div
          *rbacOrgAllow="[permissions.OrganizationDatabaseDoorsDirectory]"
          class="flex-row start-center"
        >
          <div
            class="menu-item flex-row start-center"
            (click)="toggleSubmenu(groupType.Doors)"
          >
            <span
              class="ui-icon-expand-arrow"
              [class.expanded]="menuExp[groupType.Doors]"
            ></span>
            <mat-icon class="menu-item-icon" svgIcon="door"></mat-icon>
            <div class="label m-10">{{ 'DATABASE.DOORS_DIR' | translate }}</div>
          </div>
        </div>
        <div *ngIf="menuExp[groupType.Doors]" class="sub-menu flex-col gap-8">
          <div
            matTooltip="Doors"
            [matTooltipDisabled]="!collapsed"
            matTooltipPosition="right"
            [routerLink]="routerSegments.doors"
            routerLinkActive="active"
          >
            {{ 'DATABASE.DOORS' | translate }}
          </div>
          <div
            [routerLink]="routerSegments.groups + '/' + groupType.Doors"
            routerLinkActive="active"
          >
            {{ 'DATABASE.GROUPS' | translate }}
          </div>
        </div>
        <div
          *rbacOrgAllow="[permissions.OrganizationDatabaseVehiclesDirectory]"
          class="flex-row start-center"
        >
          <div
            class="menu-item flex-row start-center"
            (click)="toggleSubmenu(groupType.Vehicles)"
          >
            <span
              class="ui-icon-expand-arrow"
              [class.expanded]="menuExp[groupType.Vehicles]"
            ></span>
            <mat-icon
              class="menu-item-icon"
              svgIcon="object-vehicle"
            ></mat-icon>
            <div class="label m-10">
              {{ 'DATABASE.VEHICLES_DIR' | translate }}
            </div>
          </div>
        </div>
        <div
          *ngIf="menuExp[groupType.Vehicles]"
          class="sub-menu flex-col gap-8"
        >
          <div
            matTooltip="Vehicles"
            [matTooltipDisabled]="!collapsed"
            matTooltipPosition="right"
            [routerLink]="routerSegments.vehicles"
            routerLinkActive="active"
          >
            {{ 'DATABASE.VEHICLES' | translate }}
          </div>
          <div
            [routerLink]="routerSegments.vehicleGroups"
            routerLinkActive="active"
          >
            {{ 'DATABASE.GROUPS' | translate }}
          </div>
        </div>
        <div
          *rbacOrgAllow="[permissions.OrganizationDatabaseEventTags]"
          class="flex-row start-center gap-10 menu-item"
          matTooltip="Event tags"
          [matTooltipDisabled]="!collapsed"
          matTooltipPosition="right"
          [routerLink]="routerSegments.eventTypes"
          routerLinkActive="active"
        >
          <mat-icon
            class="menu-item-icon event-tags"
            svgIcon="custom-event"
          ></mat-icon>
          <div class="label">{{ 'DATABASE.EVENT_TAGS' | translate }}</div>
        </div>
        <div
          class="menu-item flex-row start-center gap-10"
          matTooltip="Time schedule"
          [matTooltipDisabled]="!collapsed"
          matTooltipPosition="right"
          [routerLink]="routerSegments.schedule"
          routerLinkActive="active"
        >
          <span class="ui-icon-calendar ui-icon"></span>
          <div class="label">{{ 'DATABASE.TIME_SCHEDULE' | translate }}</div>
        </div>
        <div
          *rbacOrgAllow="[permissions.OrganizationDatabaseEventTags]"
          class="menu-item flex-row start-center gap-10"
          matTooltip="Youtube"
          [matTooltipDisabled]="!collapsed"
          matTooltipPosition="right"
          [routerLink]="routerSegments.youtube"
          routerLinkActive="active"
        >
          <span class="ui-icon-youtube ui-icon"></span>
          <div class="label">{{ 'DATABASE.YOUTUBE' | translate }}</div>
        </div>
        <div
          *rbacOrgAllow="[permissions.OrganizationDatabaseEntrances]"
          class="menu-item flex-row start-center"
          matTooltip="Entrances"
          [matTooltipDisabled]="!collapsed"
          matTooltipPosition="right"
          [routerLink]="routerSegments.entrances"
          routerLinkActive="active"
        >
          <mat-icon
            class="menu-item-icon entrances"
            svgIcon="entrance"
          ></mat-icon>
          <div class="label">{{ 'DATABASE.ENTRANCES' | translate }}</div>
        </div>
        <div
          *rbacOrgAllow="[permissions.OrganizationDatabaseEntrances]"
          class="menu-item flex-row start-center"
          matTooltip="Variables"
          [matTooltipDisabled]="!collapsed"
          matTooltipPosition="right"
          [routerLink]="routerSegments.variables"
          routerLinkActive="active"
        >
          <mat-icon
            class="menu-item-icon entrances"
            svgIcon="variables"
          ></mat-icon>
          <div class="label">{{ 'DATABASE.VARIABLES' | translate }}</div>
        </div>
        <div
          class="menu-item flex-row start-center"
          [routerLink]="routerSegments.tags"
          routerLinkActive="active"
        >
          <mat-icon class="menu-item-icon entrances" svgIcon="tag"></mat-icon>
          <div class="label">{{ 'DATABASE.TAGS' | translate }}</div>
        </div>
        <ng-container *ngIf="(selectIsDeveloper$ | async) || (enableShelves$ | async) ">
          <div
            class="menu-item flex-row start-center"
            [routerLink]="routerSegments.shelfs"
            routerLinkActive="active"
            *rbacOrgAllow="[permissions.OrganizationDatabase]"
          >
            <mat-icon
              class="menu-item-icon entrances"
              svgIcon="shelves"
            ></mat-icon>
            <div class="label">{{ 'DATABASE.SHELFS' | translate }}</div>
          </div>
        </ng-container>
        <ng-container *ifDeveloper>
          <div
            class="menu-item flex-row start-center"
            [routerLink]="routerSegments.zoneRegions"
            routerLinkActive="active"
            *rbacOrgAllow="[permissions.OrganizationDatabase]"
          >
            <span class="ui-icon-annotation menu-item-icon entrances"></span>
            <div class="label">{{ 'DATABASE.ZONE_REGIONS' | translate }}</div>
          </div>
        </ng-container>
        <div
          *rbacOrgAllow="[permissions.OrganizationDatabase]"
          class="menu-item flex-row start-center"
          [routerLink]="routerSegments.mapObjects"
          routerLinkActive="active"
        >
          <span class="ui-icon-map-object menu-item-icon entrances icon"></span>
          <div class="label">
            {{ 'ORG_SETTINGS.MENU.CUSTOM_OBJECTS_MAP' | translate }}
          </div>
        </div>
        <ng-container *ifDeveloper>
          <div
            *rbacOrgAllow="[permissions.OrganizationDatabase]"
            class="menu-item flex-row start-center"
            [routerLink]="routerSegments.workflowWebhooks"
            routerLinkActive="active"
          >
            <span class="ui-icon-webhook menu-item-icon entrances icon"></span>
            <div class="label">
              {{ 'DATABASE.WEBHOOK' | translate }}
            </div>
          </div>
          <div
            *rbacOrgAllow="[permissions.OrganizationDatabase]"
            class="flex-row start-center"
          >
            <div
              class="menu-item flex-row start-center"
              (click)="toggleContactsDirectorySubmenu()"
            >
            <span
              class="ui-icon-expand-arrow"
              [class.expanded]="isContactsDirectoryExpanded"
            ></span>
              <span class="ui-icon-accessibility menu-item-icon"></span>
              <div class="label m-10">
                {{ 'ORG_SETTINGS.MENU.CONTACTS' | translate }}
              </div>
            </div>
          </div>
          <div
            *ngIf="isContactsDirectoryExpanded"
            class="sub-menu flex-col gap-8"
          >
            <div
              [routerLink]="routerSegments.contacts"
              routerLinkActive="active"
            >
              {{ 'ORG_SETTINGS.MENU.CONTACTS' | translate }}
            </div>
            <ng-container *ifDeveloper>
              <div
                [routerLink]="routerSegments.contactGroups"
                routerLinkActive="active"
              >
                {{ 'CONTACT_GROUPS.MENU_TITLE' | translate }}
              </div>
            </ng-container>
          </div>
        </ng-container>
        <div
          *rbacOrgAllow="[permissions.OrganizationDatabase]"
          class="menu-item flex-row start-center"
          [routerLink]="routerSegments.categories"
          routerLinkActive="active"
        >
          <span class="ui-icon-category menu-item-icon entrances icon"></span>
          <div class="label">
            {{ 'DATABASE.CATEGORIES' | translate }}
          </div>
        </div>
      </div>
      <div class="router-wrapper">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ng-container>
